export const APPEARANCE_THEMES = ['light', 'dark', 'blue-white'] as const;

export type AppearanceTheme = (typeof APPEARANCE_THEMES)[number];

interface AppearanceThemeShortcutEvent {
  altKey: boolean;
  ctrlKey: boolean;
  key: string;
  metaKey: boolean;
  repeat: boolean;
  shiftKey: boolean;
}

/**
 * Mod+Shift+Y on every platform. Mod+Shift+digits stay with the editor
 * heading shortcuts; the letter follows the keyboard layout.
 */
export function appearanceThemeShortcutKeys(isMac: boolean): string[] {
  return [isMac ? '⌘' : 'Ctrl', '⇧', 'Y'];
}

export function getNextAppearanceTheme(
  theme: string | undefined,
  resolvedTheme: string | undefined
): AppearanceTheme {
  const activeTheme = theme === 'system' ? resolvedTheme : theme;
  const activeIndex = APPEARANCE_THEMES.findIndex(
    candidate => candidate === activeTheme
  );

  return APPEARANCE_THEMES[(activeIndex + 1) % APPEARANCE_THEMES.length];
}

export function isAppearanceThemeRotationShortcut(
  event: AppearanceThemeShortcutEvent,
  isMac: boolean
): boolean {
  const mod = isMac
    ? event.metaKey && !event.ctrlKey
    : event.ctrlKey && !event.metaKey;
  return (
    mod &&
    event.shiftKey &&
    !event.altKey &&
    !event.repeat &&
    event.key.toLowerCase() === 'y'
  );
}
